module.exports = __webpack_public_path__ + "static/graphql-2347dbbf82bfe14272f1568d6a15ec6f.png";